import { render, staticRenderFns } from "./SellerShippingSettings.vue?vue&type=template&id=6fb8d66e"
import script from "./SellerShippingSettings.vue?vue&type=script&lang=js"
export * from "./SellerShippingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports